<div class="modalTerminos content">
  <div class="modalTerminos__header">
    <h1 class="titulo">Términos y condiciones</h1>
    <div class="iconoCerrar">
      <ion-icon (click)="iconoCerrar()" class="icon i-close" (keydown.enter)="iconoCerrar()"></ion-icon>
    </div>
  </div>
  <div class="modalTerminos__body">
    <div class="modalTerminos__body-info">
      <ol class="terminos-list">
        <li class="main-info-text">
          Esta solicitud faculta a mantener el valor en pesos del saldo que tienes a 
          la fecha de la solicitud de pensión, hasta que ésta sea concedida, rechazada o desistas 
          de pensionarte. El valor en pesos del saldo será fijado de acuerdo 
          con la fecha de traspaso a la Cuenta Corriente del Fondo de Pensión.
        </li>

        <li class="main-info-text">
          Con el congelamiento, tu saldo no presentará variaciones ni positivas ni negativas 
          durante el período antes mencionado, 
          dado a que se mantendrá en la Cuenta Corriente del Fondo de Pensión.
        </li>

        <li class="main-info-text">
          Las potenciales pérdidas de rentabilidad positiva por elegir congelar tu saldo son asumidas 
          íntegramente y con pleno uso de las facultades del solicitante, al momento de suscribir este 
          traspaso. Además, se debe tener en cuenta que, durante el período antes mencionado no es posible 
          realizar las siguiente acciones:
          <ul class="actions-list">
            <li>Traspaso a otra AFP</li>
            <li>Suscribir pago en exceso</li>
            <li>Suscribir cambio en distribución de fondo</li>
            <li>Aplicar cambio etario</li>
            <li>Suscribir retiro de APV</li>
            <li>Recibir cartola mensual</li>
          </ul>
        </li>

        <li class="main-info-text">
          El traspaso a la Cuenta Corriente del Fondo de Pensión no es inmediato y 
          sólo se hará efectivo al cuarto día hábil de confirmado el ingreso vía 
          telefónica y acompañado de un respaldo a tu correo. La opción establecida 
          en esta solicitud nace a propósito de la Norma de carácter general Número 
          264 de la Superintendencia de Pensiones, con fecha 21 de abril de 2020.
        </li>
      </ol>
    </div>
  </div>
  <div class="modalTerminos__buttons">
    <ion-button
      shape="round"
      (click)="botonAceptar()"
      (keydown.enter)="botonAceptar()"
      expand="full"
      class="next"
    >
      <ion-label>Aceptar</ion-label>
    </ion-button>
  </div>
</div>
